Bingo.Tables = {};

Bingo.Tables.openControl = function (control) {
    const items = control.find('.js-table__controlItems');

    items.css('width', '0px');
    control.addClass('-open');

    const itemsClone = items.clone().css({
        visibility: 'hidden',
        position: 'absolute',
        'z-index': '-99999',
        left: '99999999px',
        top: '0px',
        width: 'auto',
    }).appendTo('body');
    const width = itemsClone.width();
    itemsClone.remove();

    items.animate({
        width: `${width}px`,
    }, 500, () => {
        items.attr('style', '');
    });
};

Bingo.Tables.closeControl = function (control) {
    const items = control.find('.js-table__controlItems');

    items.animate({
        width: '0px',
    }, 500, () => {
        control.removeClass('-open');
        items.attr('style', '');
    });
};

Bingo.Tables.init = function () {
    $('.js-table__control').removeClass('-open');
    $(document).on('click', '.js-table__controlToggler', function (e) {
        e.preventDefault();
        const control = $(this).closest('.js-table__control');
        const toggler = control.find('.js-table__controlToggler');
        if (control.hasClass('-open')) {
            Bingo.Tables.closeControl(control);
            toggler.find('.A-circle').blur();
        } else {
            Bingo.Tables.closeControl(control.closest('.O-table').find(('.js-table__control.-open')));
            Bingo.Tables.openControl(control);
        }
    });
    $(document).on('click', '.js-tablePerPageItem', function () {
        const value = $(this).data('value');
        const select = $(this).closest('.M-paginator').find('.js-tablePerPageSelect');
        const submit = $(this).closest('.M-paginator').find('.js-tablePerPageSubmit');
        select.val(value);
        submit.click();
    });
};
